import { render, staticRenderFns } from "./AddAvoir.vue?vue&type=template&id=f8616a02&"
import script from "./AddAvoir.vue?vue&type=script&lang=js&"
export * from "./AddAvoir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports